import type { BillingCurrency } from "../../../convex/lib/billingRail";

export type CheckoutMethodId = "wam" | "paypal";

export type CheckoutLogoChip = "wam" | "paypal";

export type CheckoutMethod = {
  id: CheckoutMethodId;
  currency: BillingCurrency;
  label: string;
  detail: string;
  /** Public SVG. Wam sits on a dark chip; PayPal sits on a white chip. */
  logoSrc: string;
  logoAlt: string;
  chip: CheckoutLogoChip;
};

/** Add a method here when a new rail exists for that currency. */
export const CHECKOUT_METHODS: readonly CheckoutMethod[] = [
  {
    id: "wam",
    currency: "TTD",
    label: "Wam",
    detail: "Pay in Trinidad and Tobago dollars",
    logoSrc: "/branding/wam.svg",
    logoAlt: "Wam",
    chip: "wam",
  },
  {
    id: "paypal",
    currency: "USD",
    label: "Card or PayPal",
    detail: "Debit or credit card, or your PayPal account",
    logoSrc: "/branding/paypal.svg",
    logoAlt: "PayPal",
    chip: "paypal",
  },
];

export function methodsForCurrency(currency: BillingCurrency): CheckoutMethod[] {
  return CHECKOUT_METHODS.filter((method) => method.currency === currency);
}
